module.exports = __webpack_public_path__ + "img/logo-default.5dd54a30.png";